module.exports = __webpack_public_path__ + "static/media/scale-design-mobile@3x.87ebf764.png";